import { API } from '../../providers/ApiInterceptorProvider';
import { CreateNoteRequest, Note } from './types';

export const notesApi = {
  getBtlNotes: async (applicationId: string): Promise<Note[]> => {
    try {
      const { data } = await API.get<Note[]>(`/monolith/btl-applications/${applicationId}/notes`);
      return data;
    } catch (err: any) {
      throw new Error(err.response?.data?.message ?? err.message);
    }
  },
  createBtlNote: async (applicationId: string, body: CreateNoteRequest): Promise<Note> => {
    try {
      const { data } = await API.post<Note>(`/monolith/btl-applications/${applicationId}/notes`, body);
      return data;
    } catch (err: any) {
      throw new Error(err.response?.data?.message ?? err.message);
    }
  },
};
